// extracted by mini-css-extract-plugin
module.exports = {"toolbarItem":"u6voDlnc","icon":"_3OkgW6pk"};